export const FETCH_PAYMENT_GATEWAYS_REQUEST = "FETCH_PAYMENT_GATEWAYS_REQUEST";
export const UPDATE_PAYMENT_GATEWAY_REQUEST = "UPDATE_PAYMENT_GATEWAY_REQUEST";
